import { createFeatureSelector, createSelector } from "@ngrx/store";

import { LoadingState, getError } from "@core/models";

import {
  labelPrintersAdapter,
  LabelPrintersState
} from "./label-printers.state";




const selectFeature = createFeatureSelector<LabelPrintersState>('labelPrinters');

const {
  selectAll,
  selectEntities,
  selectTotal,
} = labelPrintersAdapter.getSelectors(selectFeature);

const selectCallState = createSelector(selectFeature, (state) => state.callState);
const selectIsLoading = createSelector(selectFeature, (state) => { return state.callState === LoadingState.LOADING });
const selectIsLoaded = createSelector(selectFeature, (state) => { return state.callState === LoadingState.LOADED });
const selectError = createSelector(selectCallState, (callState) => getError(callState));

const selectDefaultPrinter = createSelector(
  selectAll,
  (labelPrinters) => {
    return labelPrinters.find(x => x.isPrimary) || null;
  });

// const selectPrinter = (printerId: string) => createSelector(
//   selectEntities,
//   (labelPrinters) => {
//     return labelPrinters[printerId] ?? null;
//   });

export const LabelPrintersSelectors = {
  callState: selectCallState,
  all: selectAll,
  total: selectTotal,
  isLoading: selectIsLoading,
  isLoaded: selectIsLoaded,
  error: selectError,
  defaultPrinter: selectDefaultPrinter,
  //selectPrinter: (printerId: string) => selectPrinter(printerId),
}